export enum DealerQueryKeyEnum {
  DEALER_LIST = "dealer-list",
  DEALER_CAR_LIST = "dealer-car-list",
}

export enum DealerKeys {
  DEALER_LOCALTION_LIST = 'DEALER_LOCALTION_LIST'
}